// extracted by mini-css-extract-plugin
export var cta = "TrainingStyle-module--cta--fcc11";
export var ctaWrapper = "TrainingStyle-module--ctaWrapper--94bf4";
export var holder = "TrainingStyle-module--holder--21357";
export var scheduleTable = "TrainingStyle-module--scheduleTable--e7b2e";
export var tableWrapper = "TrainingStyle-module--tableWrapper--4092e";
export var title = "TrainingStyle-module--title--f0c90";
export var wrapper = "TrainingStyle-module--wrapper--70931";